import { useRouter } from 'next/router';
import { useIsAppointmentPath } from '~/hooks/useIsAppointmentPath';
import { isPharmacyBookingPath, requiresPharmacyBookingAnonymousSession } from '~/features/pharmacy-booking/routes';

/**
 * medinavi-backend consumer GraphQL（X-Ubie-Authorization）を使うパス。
 * 管理ページ（GraphQL のみ・Orthrus 不要）も含む。
 */
export const useIsMedinaviBackendPath = (): boolean => {
  const router = useRouter();
  const isAppointmentPath = useIsAppointmentPath();
  return isAppointmentPath || isPharmacyBookingPath(router.pathname);
};

/**
 * ofro create-anonymous で Orthrus 匿名 PersonID を用意する必要があるパス。
 * 薬局予約の管理 URL は除外する。
 */
export const useRequiresMedicoAnonymousAccount = (): boolean => {
  const router = useRouter();
  const isAppointmentPath = useIsAppointmentPath();
  return isAppointmentPath || requiresPharmacyBookingAnonymousSession(router.pathname);
};
